export default `p=fract(p)-.5;
    vec3 O=vec3(2.,0.0,3.);
    for(int j=0;j++<7;){
      p=abs(p);
      p=(p.x < p.y?p.zxy:p.zyx)*3.-O;
      if(p.z < -.5*O.z)
      p.z+=O.z;
    }
    return length(p.xy)/3e3;
  }`